import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchBoletins } from "../hooks/fetchBoletins";
import SectionTitle from "../../../components/SectionTitle";
import CardBoletim from "../../noticias/sections/CardBoletim";

export default function BoletinsEvento({ idEvento }) {
  const [page, setPage] = useState(1);

  const {
    data,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["boletins", idEvento, page],
    queryFn: () => fetchBoletins({ idEvento, page }),
    enabled: !!idEvento,
  });

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  if (isError) return null;

  return (
    <section>
      <SectionTitle color="infoLight">Boletins do Evento:</SectionTitle>
      <CardBoletim
        boletinsSection={false}
        boletins={data?.boletins || []}
        loadingBoletins={isLoading}
        errorBoletins={isError}
        handleChange={handleChangePage}
        totalPages={data?.totalPages || 1}
        page={page}
      />
    </section>
  );
}
